import { pathToName } from '../../utils';
const componentsMap = {};
export function setComponetsMap(components) {
    for (const key in components) {
        const name = pathToName(key);
        componentsMap[name] = components[key];
    }
}
const loadedComponents = {};
export function getComponent(name) {
    return loadedComponents[name]?.default || null;
}
export async function loadComponents(deps) {
    const promises = deps.map(async (name) => {
        if (!componentsMap[name])
            return;
        const module = await componentsMap[name]();
        if (module.load)
            await module.load();
        loadedComponents[name] = module;
    });
    await Promise.all(promises);
}
